import { authService } from "@/services";
import { loginResponse } from "@/services/api-schema";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    user: {},
    status: {
      loggedIn: false,
      loggingIn: false,
      error: false,
    },
    userSchemas: localStorage.getItem("user_schemas")
      ? JSON.parse(localStorage.getItem("user_schemas"))
      : [],
  },
  getters: {
    getStatus(state) {
      return state.status;
    },
  },
  mutations: {
    loginRequest(state, user) {
      state.status.loggingIn = true;
      state.status.error = false;
      state.user = user;
    },
    loginSuccess(state, { user, schemas }) {
      state.status.loggedIn = true;
      state.status.loggingIn = false;
      state.status.error = false;
      state.user = user;
      state.userSchemas = schemas;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.status.loggingIn = false;
      state.status.error = true;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = true;
      state.status.loggingIn = false;
      state.user = null;
      state.userSchemas = null;
    },
  },
  actions: {
    login({ commit }, { username, password, redirection }) {
      commit("loginRequest", { username });

      authService.login(username, password).then(
        (user) => {
          commit("loginSuccess", {
            user: username,
            schemas: user[loginResponse.userSchemas],
          });
          router.push(redirection);
        },
        (error) => {
          commit("loginFailure", error);
          // dispatch("alert/error", error, { root: true });
        }
      );
    },
    logout({ commit }) {
      authService.logout();
      commit("logout");
    },
  },
};
